import { Inject, Injectable } from '@angular/core';
import { Auth } from '@freelancer/auth';
import { Datastore } from '@freelancer/datastore';
import { UI_CONFIG } from '@freelancer/ui/ui.config';
import { UiConfig } from '@freelancer/ui/ui.interface';
import { EnterpriseApi } from 'api-typings/common/common';
import * as Rx from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { Feature, FeatureFlagConfig, SiteTheme } from './feature-flags.model';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagsService {
  // FIXME: Should be { [theme: SiteTheme] : FeatureFlagConfig } but there is no SiteTheme type yet.
  // FIXME: Compile static configurations from single-source of truth
  private configurations: { [siteName in SiteTheme]: FeatureFlagConfig } = {
    arrow: {
      memberships: false,
      contests: true,
      contestPost: false,
      localJobs: false,
      showcase: false,
      search: false,
      community: false,
      referAClient: true,
      giveGet: false,
      howItWorksPage: false,
      enterprisePage: false,
      aboutFlnltdPages: false,
      projectManagementPage: false,
      services: false,
      polls: false,
      gamification: false,
      preferredFreelancerProgram: false,
      fileUpload: true,
      portfolio: true,
      legacyFreelancerProjectViewPage: true,
    },

    deloitte: {
      memberships: true,
      contests: true,
      contestPost: true,
      localJobs: true,
      showcase: true,
      search: true,
      community: true,
      referAClient: true,
      giveGet: true,
      howItWorksPage: true,
      enterprisePage: true,
      aboutFlnltdPages: true,
      projectManagementPage: true,
      services: true,
      polls: true,
      gamification: true,
      preferredFreelancerProgram: true,
      fileUpload: false,
      portfolio: false,
      legacyFreelancerProjectViewPage: false,
    },
  };

  constructor(
    private datastore: Datastore,
    private auth: Auth,
    @Inject(UI_CONFIG) private uiConfig: UiConfig,
  ) {}

  getFlag(feature: Feature): Rx.Observable<boolean> {
    if (
      this.uiConfig.theme !== undefined &&
      this.uiConfig.theme in this.configurations
    ) {
      return Rx.of(this.configurations[this.uiConfig.theme][feature]);
    }

    return this.auth.isLoggedIn().pipe(
      switchMap(loggedIn =>
        loggedIn
          ? this.datastore
              .document('users', this.auth.getUserId())
              .valueChanges()
              .pipe(
                map(user => {
                  if (
                    user.enterpriseIds !== undefined &&
                    !!user.enterpriseIds.find(
                      id => id === EnterpriseApi.DELOITTE_DC,
                    )
                  ) {
                    return this.configurations[SiteTheme.DELOITTE][feature];
                  }
                  return true;
                }),
              )
          : Rx.of(true),
      ),
    );
  }
}
